import * as React from "react";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import AcUnitRoundedIcon from "@mui/icons-material/AcUnitRounded";
import SatelliteAltRoundedIcon from "@mui/icons-material/SatelliteAltRounded";

// missions.icon_key -> icon. The DB can't store a React node, so this is
// the one place a new icon_key needs a matching entry -- everything else
// about a mission (name, objective, payloads...) is pure data. The admin
// form sets icon_key to the mission's slug on create, so key entries by slug;
// anything without an entry falls back to the satellite icon.
const MISSION_ICONS: Record<string, React.ElementType> = {
  "ghost-ship": VisibilityOffRoundedIcon,
  glacier: AcUnitRoundedIcon,
};

export function getMissionIcon(iconKey: string): React.ElementType {
  return MISSION_ICONS[iconKey] ?? SatelliteAltRoundedIcon;
}
